module.exports = "/_next/static/images/hero-image-b12305e5c94bf2abb937947e50edd00c.jpg";